module.exports = __webpack_public_path__ + "media/directory/company_icon-ee03cd88.svg";